/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {Login} from './components/Login'
import {toAbsoluteUrl} from '../../../_metronic/helpers'

export function AuthPage() {
  useEffect(() => {
    document.body.classList.add('bg-white')
    return () => {
      document.body.classList.remove('bg-white')
    }
  }, [])

  return (
    <div
      className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
      style={{
        backgroundImage: `linear-gradient(rgba(255,255,255,.15), rgba(255,255,255,.15)), url(${toAbsoluteUrl('/media/background/fondo.png')})`, backgroundSize: '100%',
      }}
    >
      {/* begin::Content */}
      <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
        {/* begin::Logo /}
        <a href='#' className='mb-12'>
          <img alt='Logo' src={toAbsoluteUrl('/media/logos/logo-1.svg')} className='h-45px' />
        </a>
        {/* end::Logo */}
        {/* begin::Wrapper */}
        <div className='w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto' style={{ marginTop: '250px' }}>
          <Switch>
            <Route path='/auth/login' component={Login} />
            {/*<Route path='/auth/registration' component={Registration} />
            <Route path='/auth/forgot-password' component={ForgotPassword} />*/}
            <Redirect from='/auth' exact={true} to='/auth/login' />
            <Redirect to='/auth/login' />
          </Switch>
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}
      {/* begin::Footer */}
      <div className='d-flex flex-center flex-column-auto'>
        <div className='d-flex align-items-center fw-bold fs-6'>
          <a href='https://abei.com.ar/' className='text-muted text-hover-primary px-2' target={'_blank'} rel="noreferrer">
            Sobre ABEI
          </a>

          <a href='https://abei.com.ar/#!/-contacto-1/' className='text-muted text-hover-primary px-2' target={'_blank'} rel="noreferrer">
            Contactanos
          </a>
        </div>
      </div>
      {/* end::Footer */}
    </div>
  )
}
